import { localStorageApiConnector } from 'apiConnector/local-torage';
import { toDateString } from 'utils/core/date';
import { now } from 'utils/core/now';
import { getNewGuid } from 'utils/guid';
import { httpClient as oldHttpClient } from 'utils/http.old/httpClient';
import { httpClient } from 'utils/http/httpClient';
import { getFrontLogger } from 'utils/loggers/FrontLogger';
import type { Streaming } from 'utils/streaming/model';
import { getFrontVersion } from 'utils/version';

import { bootstrapStore } from './bootstrapStore';
import type { ExtraArgument } from './state.common';

export function configureStore(streaming: Streaming) {
  return bootstrapStore(storeExtraArguments(streaming));
}

export function getSgmeConfiguration(): Readonly<SgmeConfiguration> {
  const config = window.sgmeConfiguration;

  if (config.enableFakeSso) {
    const overrideClientId = sessionStorage.getItem('E2eClientIdPersona');

    if (overrideClientId) {
      return {
        ...config,
        sgConnect: {
          ...config.sgConnect,
          client_id: overrideClientId,
        },
      } satisfies SgmeConfiguration;
    }
  }
  return config;
}

export const storeExtraArguments = (streaming: Streaming): Omit<ExtraArgument, 'selectors'> => ({
  frontLogger: getFrontLogger(),
  httpClient,
  oldHttpClient,
  localStorageApiConnector,
  streaming,
  getNewGuid,
  getNow: () => now(),
  getTodayString: () => {
    const dateNow = now();
    dateNow.setUTCHours(0, 0, 0, 0);
    return toDateString(dateNow);
  },
  getFrontVersion,
  getSgmeConfiguration,
  isPageVisible: () => {
    const document = window.document;
    return document ? !document.hidden : true;
  },
  navigateTo: (path, subRoutePath) => (window.location.hash = `#${path}${subRoutePath || ''}`),
});
